import React from 'react';

import Box from '@glass/web/components/base/Box';
import Typography from '@glass/web/components/base/Typography';
import Grid from '@glass/web/components/base/Unstable_Grid2';
import cardBreakpoints from '@glass/web/modules/theme/cardBreakpoints';

import Breadcrumbs from '@glass/shared/components/Breadcrumbs/Breadcrumbs';
import AuthProfileCard from '@glass/shared/components/Profile/AuthProfileCard';
import ProfileCardMenu from '@glass/shared/components/Profile/ProfileCardMenu';
import ProfileLayoutPage from '@glass/shared/components/Profile/ProfileLayoutPage';
import UserResumes from '@glass/shared/components/Profile/UserResumes';
import useResumeWords from '@glass/shared/modules/content/staticVariations/resumeWords/useResumeWords';

export const ACCOUNT_PAGE_TITLE = 'Account';

const items = [{ text: ACCOUNT_PAGE_TITLE }];

function ProfilePage() {
  const resumeWords = useResumeWords();

  return (
    <ProfileLayoutPage pageTitle={ACCOUNT_PAGE_TITLE}>
      <Grid container spacing={1}>
        <Grid xs={12}>
          <Box mb={1}>
            <Breadcrumbs items={items} variant="h2" />
          </Box>
        </Grid>
        <Grid
          lg={cardBreakpoints.lg}
          md={cardBreakpoints.md}
          xl={cardBreakpoints.xl}
          xs={cardBreakpoints.xs}
        >
          <AuthProfileCard action={<ProfileCardMenu />} />
        </Grid>
        <Grid xs={12}>
          <Box mb={1} mt={2}>
            <Typography variant="h2">{resumeWords.pluralCapitalized}</Typography>
          </Box>
        </Grid>
        <Grid xs={12}>
          <UserResumes />
        </Grid>
      </Grid>
    </ProfileLayoutPage>
  );
}

export default ProfilePage;
